import { render, staticRenderFns } from "./SecondStep.vue?vue&type=template&id=763d7e60&"
import script from "./SecondStep.vue?vue&type=script&lang=ts&"
export * from "./SecondStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports